import type { FC } from "react";

import { LoyaltyVideoPlayer as UILoyaltyVideoPlayer } from "@jti/loyalty";

import { buildLoyaltyVideoUIProps } from "@/components/LoyaltyVideoPlayer/buildLoyaltyVideoUIProps";
import type { loyaltyVideoPlayerInputs } from "@/components/LoyaltyVideoPlayer/LoyaltyVideoPlayer.builder";

export type LoyaltyVideoPlayerProps = BuilderComponentProps<typeof loyaltyVideoPlayerInputs>;

export const LoyaltyVideoPlayer: FC<LoyaltyVideoPlayerProps> = (props) => {
  const videoProps = buildLoyaltyVideoUIProps(props);

  if (!videoProps) {
    return null;
  }

  return <UILoyaltyVideoPlayer {...videoProps} />;
};
